<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="col-12">
      <p-card styleClass="very-compact-card p-3">
        <div class="p-fluid">
          <div class="field">
            <label class="font-medium required-field">Название</label>
            <crm-input-text
              [(value)]="scenario.name"
              [isError]="$any(errors?.name)"></crm-input-text>
            <small
              *ngIf="errors?.name"
              class="p-error">
              {{ errors.name | join }}
            </small>
          </div>
        </div>
      </p-card>

      <p-card styleClass="very-compact-card mt-3 p-3">
        <h3 class="required-field">ЕСЛИ</h3>

        <div *ngIf="errors?.conditions">
          <small class="p-error">
            {{ errors.conditions | join }}
          </small>
        </div>

        <ng-container *ngFor="let condition of scenario.conditions; let index = index">
          <div class="p-fluid">
            <div class="field">
              <div class="flex align-items-center gap-3">
                <crm-payment-task-scenario-condition-kind-single-select
                  [(kind)]="condition.kind"
                  (kindChange)="setConditionOptions(condition)"
                  class="flex-grow-1"
                  appendTo="body"></crm-payment-task-scenario-condition-kind-single-select>

                <i
                  class="pi pi-times text-red-500 hover:text-red-400 cursor-pointer"
                  style="font-size: 1.5rem"
                  (click)="deleteCondition(condition)"></i>
              </div>
            </div>
            <div
              *ngIf="condition.kind !== PaymentScenarionConditionKindEnum.EXCEEDING_PLAN"
              class="field">
              <crm-payment-task-scenario-condition-type-single-select
                [(type)]="condition.type"
                [kind]="condition.kind"
                styleClass="w-9rem"
                appendTo="body">
              </crm-payment-task-scenario-condition-type-single-select>
            </div>
            <div class="field">
              <ng-container [ngSwitch]="condition.kind">
                <ng-container *ngSwitchCase="PaymentScenarionConditionKindEnum.DIRECTION">
                  <crm-direction-multi-select
                    [directions]="directions"
                    [(selectedDirections)]="condition.directions"
                    [styleClass]="errors?.conditions?.[index]?.directions ? 'ng-invalid ng-dirty' : ''"
                    [class]="errors?.conditions?.[index]?.directions ? 'ng-invalid ng-dirty' : ''"
                    [showClear]="true"
                    appendTo="body"></crm-direction-multi-select>
                  <p
                    *ngIf="errors?.conditions?.[index]?.directions"
                    class="p-error">
                    {{ errors.conditions[index].directions | join }}
                  </p>
                </ng-container>

                <ng-container *ngSwitchCase="PaymentScenarionConditionKindEnum.UNIT">
                  <crm-unit-multi-select
                    [(selectedUnits)]="condition.units"
                    [isError]="$any(errors?.conditions?.[index]?.units)"
                    [showClear]="true"
                    [isFloatLabel]="false"
                    placeholder="Выберите единицы"
                    appendTo="body"></crm-unit-multi-select>
                  <p
                    *ngIf="errors?.conditions?.[index]?.units"
                    class="p-error">
                    {{ errors.conditions[index].units | join }}
                  </p>
                </ng-container>

                <ng-container *ngSwitchCase="PaymentScenarionConditionKindEnum.FILIAL">
                  <crm-filial-multi-select
                    [(selectedFilials)]="condition.filials"
                    [isError]="$any(errors?.conditions?.[index]?.filials)"
                    [showClear]="true"
                    [isFloatLabel]="false"
                    placeholder="Выберите филиалы"
                    appendTo="body"></crm-filial-multi-select>
                  <p
                    *ngIf="errors?.conditions?.[index]?.filials"
                    class="p-error">
                    {{ errors.conditions[index].filials | join }}
                  </p>
                </ng-container>

                <ng-container *ngSwitchCase="PaymentScenarionConditionKindEnum.COMPANY">
                  <crm-multi-select
                    [options]="companies"
                    [(selectedItems)]="condition.companies"
                    [showClear]="true"
                    [styleClass]="errors?.conditions?.[index]?.companies ? 'ng-invalid ng-dirty' : ''"
                    [class]="errors?.conditions?.[index]?.companies ? 'ng-invalid ng-dirty' : ''"
                    placeholder="Выберите плательщиков"
                    styleClass="max-w-full"
                    appendTo="body"></crm-multi-select>
                  <p
                    *ngIf="errors?.conditions?.[index]?.companies"
                    class="p-error">
                    {{ errors.conditions[index].companies | join }}
                  </p>
                </ng-container>

                <ng-container *ngSwitchCase="PaymentScenarionConditionKindEnum.AMOUNT">
                  <p-inputNumber
                    [(ngModel)]="condition.amount"
                    [ngClass]="{ 'ng-invalid ng-dirty': errors?.conditions?.[index]?.amount }"></p-inputNumber>
                  <p
                    *ngIf="errors?.conditions?.[index]?.amount"
                    class="p-error">
                    {{ errors.conditions[index].amount | join }}
                  </p>
                </ng-container>

                <ng-container *ngSwitchCase="PaymentScenarionConditionKindEnum.DEAL">
                  <crm-deal-multi-select
                    [(selectedDeals)]="condition.deals"
                    [isError]="$any(errors?.conditions?.[index]?.deals)"
                    [showClear]="true"
                    placeholder="Выберите сделки"
                    appendTo="body"></crm-deal-multi-select>
                  <p
                    *ngIf="errors?.conditions?.[index]?.deals"
                    class="p-error">
                    {{ errors.conditions[index].deals | join }}
                  </p>
                </ng-container>

                <ng-container *ngSwitchCase="PaymentScenarionConditionKindEnum.COST_CENTER">
                  <crm-cost-center-multi-select
                    [(selectedCostCenters)]="condition.costCenters"
                    [isError]="$any(errors?.conditions?.[index]?.costCenters)"
                    [showClear]="true"
                    placeholder="Выберите центры затрат"
                    appendTo="body"></crm-cost-center-multi-select>
                  <p
                    *ngIf="errors?.conditions?.[index]?.costCenters"
                    class="p-error">
                    {{ errors.conditions[index].costCenters | join }}
                  </p>
                </ng-container>

                <ng-container *ngSwitchCase="PaymentScenarionConditionKindEnum.EXCEEDING_PLAN">
                  <label class="font-medium">Выбор аналитики</label>
                  <div class="flex flex-wrap align-items-center justify-content-between gap-3">
                    <div style="width: 60%">
                      <p-selectButton
                        [options]="exceedingPlanAnalyticsModeOptions"
                        [(ngModel)]="condition.excceedingPlanAnalyticsMode">
                        <ng-template let-item>
                          <i
                            [class]="item.icon"
                            class="mr-2"></i>
                          <span> {{ item.label }} </span>
                        </ng-template>
                      </p-selectButton>
                    </div>

                    <p-selectButton
                      [options]="exceedingPlanAnalyticsKindOptions"
                      [(ngModel)]="condition.excceedingPlanAnalyticsKind">
                      <ng-template let-item>
                        <i
                          [class]="item.icon"
                          class="mr-2"></i>
                        <span class="w-6rem"> {{ item.label }} </span>
                      </ng-template>
                    </p-selectButton>
                  </div>
                </ng-container>

                <ng-container *ngSwitchCase="PaymentScenarionConditionKindEnum.BUDGET_EXHAUSTED">
                  <p-inputNumber
                    [(ngModel)]="condition.exhaustedBudgetPercent"
                    [ngClass]="{ 'ng-invalid ng-dirty': errors?.conditions?.[index]?.exhaustedBudgetPercent }"
                    prefix="%"
                    [min]="0"
                    [max]="100"></p-inputNumber>
                  <p
                    *ngIf="errors?.conditions?.[index]?.exhaustedBudgetPercent"
                    class="p-error">
                    {{ errors.conditions[index].exhaustedBudgetPercent | join }}
                  </p>
                </ng-container>

                <ng-container *ngSwitchDefault>
                  <p-skeleton height="3rem"></p-skeleton>
                </ng-container>
              </ng-container>
            </div>
          </div>

          <ng-container *ngIf="index !== scenario.conditions?.length - 1">
            <p-divider styleClass="border-1 border-300"></p-divider>
          </ng-container>
        </ng-container>

        <button
          pButton
          label="Добавить условие"
          icon="pi pi-plus"
          class="p-button-success p-button-text -ml-3"
          (click)="addCondition()"></button>
      </p-card>

      <p-card styleClass="very-compact-card mt-3 p-3">
        <h3 class="required-field">ТО</h3>
        <div *ngIf="errors?.paymentScenarionAction">
          <small class="p-error">
            {{ $any(errors.paymentScenarionAction) | joinWithChild }}
          </small>
        </div>

        <div class="p-fluid mt-3">
          <div class="field">
            <label class="font-medium">Действие</label>
            <crm-payment-task-scenario-method-single-select
              [(method)]="scenario.paymentScenarionAction.method"
              class="flex-grow-1"
              appendTo="body"></crm-payment-task-scenario-method-single-select>
          </div>

          <div class="field">
            <ng-container [ngSwitch]="scenario.paymentScenarionAction.method">
              <ng-container *ngSwitchCase="PaymentScenarionActionMethodEnum.ADD_APPROVER">
                <label class="font-medium">Согласователи</label>
                <crm-multi-select
                  [options]="users"
                  [(selectedItems)]="scenario.paymentScenarionAction.approvers"
                  appendTo="body"
                  [class]="errors?.paymentScenarionAction?.approvers ? 'ng-invalid ng-dirty' : ''"
                  [styleClass]="
                    errors?.paymentScenarionAction?.approvers ? 'ng-invalid ng-dirty' : ''
                  "></crm-multi-select>
                <p
                  *ngIf="errors?.paymentScenarionAction?.approvers"
                  class="p-error">
                  {{ errors.paymentScenarionAction.approvers | join }}
                </p>
              </ng-container>
            </ng-container>
          </div>
        </div>

        <div
          *ngIf="scenario['deleted']"
          class="text-right">
          <p-tag
            severity="danger"
            value="Удален"
            styleClass="mt-2"></p-tag>
        </div>
      </p-card>
    </div>
  </div>

  <div class="grid mt-3">
    <div class="col-12 flex flex-wrap justify-content-between">
      <div>
        <button
          pButton
          [label]="saveButtonLabel"
          class="p-button-success mr-2"
          (click)="saveScenario()"></button>
      </div>
      <ng-container *ngIf="(form$ | async)?.isShowDelete">
        <button
          *ngIf="!scenario['deleted']"
          pButton
          label="Удалить"
          class="p-button-danger p-button-text"
          (click)="deleteScenario()"></button>

        <button
          *ngIf="scenario['deleted']"
          pButton
          label="Восстановить"
          class="p-button-text"
          (click)="restoreScenario()"></button>
      </ng-container>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
